export {
    Type,
    JSON,
    fromJSON,
    fromBytes,
    fromString,
    toBytes,
    Err,
    ErrorType,
    instanceOf,
    equals,
} from '../../plt/TokenId.js';
